import React from 'react';
import { useQueryClient } from 'react-query';
import Attachment from '../../../../../../../../components/NewAttachment/NewAttachment';
import { shutdownAttachments } from '../../../../../../shared/api/queries';
import { deleteShutdownAttachment } from '../../../../../../features/shutdown';
import { getBlobUrl } from '../../../../../../../../helpers/getBlobUrl';
import styles from './AttachmentList.module.scss';

const { fetchAttachmentData } = shutdownAttachments;
const { useDeleteShutdonwAttachment } = deleteShutdownAttachment;

const getAttachmentUrl =
  ({ queryClient, shutdownId }) =>
  async (data) => {
    const fileName = typeof data === 'string' ? data : data.fileName;
    const fileExtension = fileName.split('.').pop();

    const attachData = await fetchAttachmentData({
      queryClient,
      shutdownId,
      fileName,
      options: { staleTime: Infinity },
    });

    const url = getBlobUrl(attachData, fileExtension);

    return url;
  };

const AttachmentList = ({ shownItems, attachments, shutdownId, canDelete }) => {
  const queryClient = useQueryClient();

  const { deleteAttachment } = useDeleteShutdonwAttachment();

  return (
    <ul className={styles.root}>
      {shownItems.map((attach) => (
        <li key={attach.id}>
          <Attachment
            className={styles.attachment}
            attachments={attachments}
            attachment={attach}
            getAttachmentUrl={getAttachmentUrl({
              queryClient,
              shutdownId,
            })}
            onDeleteAttachment={
              canDelete
                ? (attach) =>
                    deleteAttachment({ shutdownId, attachId: attach.id })
                : undefined
            }
          />
        </li>
      ))}
    </ul>
  );
};

export default AttachmentList;
